export default {
  GET_PRODUCT_NAMES: 'GET_PRODUCT_NAMES',
  GET_PRODUCT_NAMES_SUCCESS: 'GET_PRODUCT_NAMES_SUCCESS',
  GET_PRODUCT_NAMES_FAILURE: 'GET_PRODUCT_NAMES_FAILURE',
  GET_QUESTIONS: 'GET_QUESTIONS',
  GET_QUESTIONS_SUCCESS: 'GET_QUESTIONS_SUCCESS',
  GET_QUESTIONS_FAILURE: 'GET_QUESTIONS_FAILURE',
  SET_COMPLAINT_INFO: 'SET_COMPLAINT_INFO',
  GET_QUESTIONS_CATEGORY: 'GET_QUESTIONS_CATEGORY',
  GET_QUESTIONS_CATEGORY_SUCCESS: 'GET_QUESTIONS_CATEGORY_SUCCESS',
  GET_QUESTIONS_CATEGORY_FAILURE: 'GET_QUESTIONS_CATEGORY_FAILURE',
  SAVE_USER: 'SAVE_USER',
  SAVE_USER_SUCCESS: 'SAVE_USER_SUCCESS',
  SAVE_USER_FAILURE: 'SAVE_USER_FAILURE',
  SEARCH_USER: 'SEARCH_USER',
  SEARCH_USER_SUCCESS: 'SEARCH_USER_SUCCESS',
  SEARCH_USER_FAILURE: 'SEARCH_USER_FAILURE',
  RESET_USER: 'RESET_USER',
  CALCULATE_SCORE: 'CALCULATE_SCORE',
  GET_COMPLAINT_INFO: 'GET_COMPLAINT_INFO',
  GET_COMPLAINT_INFO_FAILURE: 'GET_COMPLAINT_INFO_FAILURE',
  GET_COMPLAINT_INFO_SUCCESS: 'GET_COMPLAINT_INFO_SUCCESS',
  SAVE_COMPLAINT: 'SAVE_COMPLAINT',
  SAVE_COMPLAINT_FAILURE: 'SAVE_COMPLAINT_FAILURE',
  SAVE_COMPLAINT_SUCCESS: 'SAVE_COMPLAINT_SUCCESS',
  UPDATE_COMPLAINT: 'UPDATE_COMPLAINT',
  UPDATE_COMPLAINT_FAILURE: 'UPDATE_COMPLAINT_FAILURE',
  UPDATE_COMPLAINT_SUCCESS: 'UPDATE_COMPLAINT_SUCCESS',
  UPDATE_SINGLE_COMPLAINT: 'UPDATE_SINGLE_COMPLAINT',
  RESET_COMPLAINT_DETAIL: 'RESET_COMPLAINT_DETAIL',
  RESET_USER_ERROR: 'RESET_USER_ERROR',
  GET_PRODUCT_PURCHASE_STORE_NAMES: 'GET_PRODUCT_PURCHASE_STORE_NAMES',
  GET_PRODUCT_PURCHASE_STORE_NAMES_SUCCESS:
    'GET_PRODUCT_PURCHASE_STORE_NAMES_SUCCESS',
  GET_PRODUCT_PURCHASE_STORE_NAMES_FAILURE:
    'GET_PRODUCT_PURCHASE_STORE_NAMES_FAILURE',
  GET_ACTIVITIES: 'GET_ACTIVITIES',
  GET_ACTIVITIES_FAILURE: 'GET_ACTIVITIES_FAILURE',
  GET_ACTIVITIES_SUCCESS: 'GET_ACTIVITIES_SUCCESS',
  SAVE_ACTIVITY: 'SAVE_ACTIVITY',
  SAVE_ACTIVITY_FAILURE: 'SAVE_ACTIVITY_FAILURE',
  SAVE_ACTIVITY_SUCCESS: 'SAVE_ACTIVITY_SUCCESS',
  GET_ONE_COMPLAINT_INFO: 'GET_ONE_COMPLAINT_INFO',
  GET_ONE_COMPLAINT_INFO_FAILURE: 'GET_ONE_COMPLAINT_INFO_FAILURE',
  GET_ONE_COMPLAINT_INFO_SUCCESS: 'GET_ONE_COMPLAINT_INFO_SUCCESS',
  GET_COMPLAINT_ACTIVITIES: 'GET_COMPLAINT_ACTIVITIES',
  GET_COMPLAINT_ACTIVITIES_FAILURE: 'GET_COMPLAINT_ACTIVITIES_FAILURE',
  GET_COMPLAINT_ACTIVITIES_SUCCESS: 'GET_COMPLAINT_ACTIVITIES_SUCCESS',
  GET_COMPLAINT_CUSTOMER_INFO: 'GET_COMPLAINT_CUSTOMER_INFO',
  GET_COMPLAINT_CUSTOMER_INFO_FAILURE: 'GET_COMPLAINT_CUSTOMER_INFO_FAILURE',
  GET_COMPLAINT_CUSTOMER_INFO_SUCCESS: 'GET_COMPLAINT_CUSTOMER_INFO_SUCCESS',

  SIGNUP_USER: 'SIGNUP_USER',
  SIGNUP_USER_SUCCESS: 'SIGNUP_USER_SUCCESS',
  SIGNUP_USER_FAILURE: 'SIGNUP_USER_FAILURE',

  CLEAR_SIGNUP_ERROR: 'CLEAR_SIGNUP_ERROR',

  SIGNIN_USER: 'SIGNIN_USER',
  SIGNIN_USER_SUCCESS: 'SIGNIN_USER_SUCCESS',
  SIGNIN_USER_FAILURE: 'SIGNIN_USER_FAILURE',
  SIGNOUT: 'SIGNOUT',
  SIGNOUT_SUCCESS: 'SIGNOUT_SUCCESS',

  FORM_STEP: 'FORM_STEP',
  FORM_STEP_UPDATE: 'FORM_STEP_UPDATE',
  COMPLAINT_UPLOAD: 'COMPLAINT_UPLOAD',
  COMPLAINT_UPDATE: 'COMPLAINT_UPDATE',
  COMPLAINT_UPLOAD_SUCCESS: 'COMPLAINT_UPLOAD_SUCCESS',
  COMPLAINT_UPLOAD_FAILURE: 'COMPLAINT_UPLOAD_FAILURE',

  GET_BRANDS: 'GET_BRANDS',
  GET_BRANDS_SUCCESS: 'GET_BRANDS_SUCCESS',

  GET_STORE_ONLINE: 'GET_STORE',
  GET_STORE_ONLINE_SUCESS: 'GET_STORE_ONLINE_SUCESS',
  GET_STORE_OFFLINE: 'GET_STORE_OFFLINE',
  GET_STORE_OFFLINE_SUCESS: 'GET_STORE_OFFLINE_SUCESS',

  FILE_UPLOAD: 'FILE_UPLOAD',
  FILE_UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS',

  PLAN_SUBMIT: 'PLAN_SUBMIT',
  PLAN_UPDATE: 'PLAN_UPDATE',
  PLAN_SUBMIT_SUCCESS: 'PLAN_SUBMIT_SUCCESS',
  PLAN_SUBMIT_FAILURE: 'PLAN_SUBMIT_FAILURE',
  PLAN_UPDATE_SUCCESS: 'PLAN_UPDATE_SUCCESS',

  GET_CITY: 'GET_CITY',
  GET_CITY_SUCCESS: 'GET_CITY_SUCCESS',

  ORDER_UPDATE: 'ORDER_UPDATE',
  ORDER_UPDATE_SUCESS: 'ORDER_UPDATE_SUCESS',
  ORDER_UPLOAD: 'ORDER_UPLOAD',
  ORDER_UPLOAD_SUCCESS: 'ORDER_UPLOAD_SUCCESS',
  ORDER_UPLOAD_FAILURE: 'ORDER_UPLOAD_FAILURE',

  ORDER_STATUS_UPDATED: 'ORDER_STATUS_UPDATED',
  ORDER_STATUS_UPDATE: 'ORDER_STATUS_UPDATE',
  ORDER_DISPATCH_UPDATE: 'ORDER_DISPATCH_UPDATE',
  ORDER_DISPATCH_UPDATED: 'ORDER_DISPATCH_UPDATED',
  ORDER_DETAIL_OPEN: 'ORDER_DETAIL_OPEN',
  ORDER_DETAIL_OPENED: 'ORDER_DETAIL_OPENED',
  ORDER_DETAIL_CLOSE: 'ORDER_DETAIL_CLOSE',
  ORDER_DETAIL_CLOSED: 'ORDER_DETAIL_CLOSED',

  ORDER_STATE_UPDATE: 'ORDER_STATE_UPDATE',
  ORDER_STATE_UPDATED: 'ORDER_STATE_UPDATED',
  ORDER_SEARCH: 'ORDER_SEARCH',

  SIGNIN_SC: 'SIGNIN_SC',
  SIGNIN_SC_SUCCESS: 'SIGNIN_SC_SUCCESS',
  SIGNIN_SC_FAILURE: 'SIGNIN_SC_FAILURE',
  SC_SIGNOUT: 'SC_SIGNOUT',
  SC_SIGNOUT_SUCCESS: 'SC_SIGNOUT_SUCCESS',

  SIGNIN_RP: 'SIGNIN_RP',
  SIGNIN_RP_SUCCESS: 'SIGNIN_RP_SUCCESS',
  SIGNIN_RP_FAILURE: 'SIGNIN_RP_FAILURE',
  RP_SIGNOUT: 'RP_SIGNOUT',
  RP_SIGNOUT_SUCCESS: 'RP_SIGNOUT_SUCCESS'
};
